import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="14" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.288 2.166c.77-.95 2.023-1.425 3.256-1.095 1.693.454 2.66 2.242 2.197 3.971L9.7 5.2H11.9v8.4H2.1V5.2h6.874l.09-.339c.37-1.382-.408-2.766-1.702-3.113-.967-.259-1.974.128-2.576.916l-.498-.498zM2.8 12.901h8.4v-7H2.8v7zm5.6-3.15H5.6V9.05h2.8v.7z" fill="#000" /></svg>;